import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import SliderPnrrCerEnpal from './SliderPnrrCerEnpal';
import SliderNewPnrr from './slider_new_pnrr';
import SliderNewPnrrColumn from './slider_new_pnrr_column';
import SliderPartnershipEmail from './Slider_Partnership_Email';
import SliderPartnership from './slider_partnership';
import SliderAllBonusTransparent from './slider_all_bonus_transparent';
import SliderAllBonusShort from './slider_all_bonus_short';
import SliderBonusCasa from './slider_bonuscasa';
import SliderAllBonusShortCap from './slider_all_bonus_short_cap';
import SliderCapPrivacy from './slider_cap_privacy';
import SliderPrivacy from './slider_privacy';
import SliderPrivacyFull from './slider_privacy_full';
import SliderAppMeter from './slider_app_meter';
import SliderAllBonusBanner from './slider_all_bonus_banner';
import SliderOrganic from './slider_organic';
import SliderOrganicGeneric from './slider_organic_generic';
import SliderEngie from './components/slider_engie';
import SliderEngieShort from './components/slider_engie_short';
import SliderEngieHp from './components/slider_engie_hp';
import SliderSwitcho2 from './components/slider_switcho_2';
import SliderPapernest from './components/slider_papernest';
import SliderPapernestShort from './components/slider_papernest_short';
import SliderNewRetrofit from './components/slider_new_retrofit';
import SliderPrivacyPush from './components/slider_privacy_push';
import SliderValutazioneCaldaia from './components/slider_valutazione_caldaia';
import SliderCaldaiaMobile1 from './components/slider_caldaia_mobile_1';
import SliderCaldaiaMobile2 from './components/slider_caldaia_mobile_2';
import SliderNoicompriamo from './components/slider_noicompriamo';
import SliderVpp from './components/slider_vpp';
import SliderBonuscasaVpp from './components/slider_bonuscasa_vpp';
import SliderVppCe from './components/slider_vpp_ce';
import SliderOld from './SliderOld';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('enpal-solar-slider') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/slider-pnrr-cer-enpal" element={<SliderPnrrCerEnpal />} />
        <Route path="/slider-new-pnrr" element={<SliderNewPnrr />} />
        <Route path="/slider_new_pnrr_column" element={<SliderNewPnrrColumn />} />
        <Route path="/slider-partnership-email" element={<SliderPartnershipEmail />} />
        <Route path="/slider_partnership" element={<SliderPartnership />} />
        <Route path="/slider_all_bonus_transparent" element={<SliderAllBonusTransparent />} />
        <Route path="/slider_all_bonus_short" element={<SliderAllBonusShort />} />
        <Route path="/slider_bonuscasa" element={<SliderBonusCasa />} />
        <Route path="/slider_all_bonus_short_cap" element={<SliderAllBonusShortCap />} />
        <Route path="/slider_cap_privacy" element={<SliderCapPrivacy />} />
        <Route path="/slider_privacy" element={<SliderPrivacy />} />
        <Route path="/slider_privacy_full" element={<SliderPrivacyFull />} />
        <Route path="/slider_app_meter" element={<SliderAppMeter />} />
        <Route path="/slider_all_bonus_banner" element={<SliderAllBonusBanner />} />
        <Route path="/slider_organic" element={<SliderOrganic />} />
        <Route path="/slider_organic_generic" element={<SliderOrganicGeneric />} />
        <Route path="/slider_engie" element={<SliderEngie />} />
        <Route path="/slider_engie_short" element={<SliderEngieShort />} />
        <Route path="/slider_engie_hp" element={<SliderEngieHp />} />
        <Route path="/slider_switcho_2" element={<SliderSwitcho2 />} />
        <Route path="/slider_papernest" element={<SliderPapernest />} />
        <Route path="/slider_papernest_short" element={<SliderPapernestShort />} />
        <Route path="/slider_new_retrofit" element={<SliderNewRetrofit />} />
        <Route path="/slider_privacy_push" element={<SliderPrivacyPush />} />
        <Route path="/slider_valutazione_caldaia" element={<SliderValutazioneCaldaia />} />
        <Route path="/slider_caldaia_mobile_1" element={<SliderCaldaiaMobile1 />} />
        <Route path="/slider_caldaia_mobile_2" element={<SliderCaldaiaMobile2 />} />
        <Route path="/slider_noicompriamo" element={<SliderNoicompriamo />} />
        <Route path="/slider_vpp" element={<SliderVpp />} />
        <Route path="/slider_bonuscasa_vpp" element={<SliderBonuscasaVpp />} />
        <Route path="/slider_vpp_ce" element={<SliderVppCe />} />
        <Route path="/slider-old" element={<SliderOld />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
